const charteEngagement = [
    {
        id:1,
        categorie: 'Environnement',
        reponses:[
            "1. Le site Trash Buster s'inscrit dans la prise de conscience environnementale concernant les déchets qui nous entourent et qui polluent nos espaces collectifs/naturels.",
            "2. Les participants qui collectent des déchets sur chaque action s'engagent à jeter conformément aux consignes de tri les déchets "
        ]
    },
    {
        id:2,
        categorie: 'Réutilisation & Recyclage',
        reponses:[
            "1. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nam fuga magnam deleniti soluta illo distinctio ex laboriosam accusantium maiores sapiente earum totam nobis, sint dicta odit? Minima ex obcaecati nostrum inventore reprehenderit fugit porro, est odio maxime eius amet! Deleniti saepe quia error ex repudiandae ipsum officiis placeat distinctio aut..",
            "2. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas consectetur aliquid maiores? "
        ]
    },
    {
        id:3,
        categorie: 'Solidarité',
        reponses:[
            "1. Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptatem sed voluptas eius nemo aspernatur hic quam mollitia maiores reiciendis officia..",
            "2. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam veritatis saepe explicabo rerum fugiat aperiam optio? Earum blanditiis magnam pariatur eveniet cupiditate quam, corporis nemo dicta, deleniti fugiat dolores ducimus rerum, doloribus reprehenderit labore quo laborum exercitationem dolorem itaque aliquam sequi dolorum. Ea voluptate neque eos maxime harum dolor facilis repudiandae natus dicta pariatur voluptas obcaecati rem, adipisci ab dignissimos ullam dolores? Eius quaerat illum amet earum saepe officiis, illo cum quasi maxime corporis incidunt impedit aut veritatis. Assumenda accusamus aperiam vitae blanditiis in tempore magnam neque iure recusandae ullam provident ratione labore doloremque, saepe accusantium, porro quas fugit quod!"
        ]
    },
    {
        id:4,
        categorie: 'Gratuité',
        reponses:[
            "1. Aucune participation financière ne peut être démandée pour la collecte des déchets, c'est une iniatiative citoyenne. ",
            "2. La collecte de déchets sur les lieux privés sont exclusivements interdits, ce sont des opérations qui n'entrent pas dans le but premier du site"
        ]
    },

]

export default charteEngagement